import React from 'react';
import PropTypes from 'prop-types';

const SyncPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M32.1 17.4c0 .2 0 .4-.2.5l-3.5 3.5a1 1 0 0 1-1.4 0L23.4 18a.8.8 0 1 1 .5-1.3h2.2V16A10 10 0 0 0 8.5 9.4l-2.2-2a13 13 0 0 1 22.8 9.2h2.3c.4 0 .7.3.7.8zM16 26c3.1 0 5.9-1.4 7.7-3.5l2.1 2.1A13 13 0 0 1 3 15.4H1A.8.8 0 0 1 .3 14L4 10.6l.4-.3c.4 0 .7 0 1 .3L8.8 14a.7.7 0 0 1-.5 1.3H6v.6a10 10 0 0 0 10 10z"
    />
  );
};

SyncPath.propTypes = {
  fill: PropTypes.string,
};

export default SyncPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/sync.jsx